<button type="button" #uploadDraftButton command="show-modal" commandfor="uploadDraftDialog"
    class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-2 transition-all ease-in-out duration-300">

    Upload Draft

    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
        <path d="M12 13v8" />
        <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
        <path d="m8 17 4-4 4 4" />
    </svg>
</button>


<el-dialog>
    <dialog #uploadDraftDialog id="uploadDraftDialog" aria-labelledby="uploadDraftDialog-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">

                        <!-- header -->
                        <div class="shrink-0 px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary">
                                        Add a Draft
                                    </p>
                                    <p class="text-sm text-secondary">
                                        Here you can add a draft on behalf of the creator.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="btn-fab-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-zinc-200 dark:divide-zinc-800 p-2">
                            <atom-add-video [focussedApplication]="focussedApplication" (videoUploaded)="onVideoUploaded($event)"></atom-add-video>

                            <div class="w-full mt-8">
                                <label for="first-name" class="block text-sm/6 font-medium text-primary">Draft
                                    Title</label>
                                <div class="mt-2">
                                    <input [(ngModel)]="draftTitle" id="first-name" type="text"
                                        autocomplete="given-name" class="input-primary text-primary" />
                                </div>
                            </div>

                        </div>
                        <!-- main content - END -->

                        <!-- Footer -->
                        <div
                            class="shrink-0 px-4 py-4 drawer-header-primary flex flex-row items-center justify-between gap-x-4">
                            <button (click)="closeDrawer()" type="button"
                                class="secondary-button inline-flex flex-row items-center gap-x-2">
                                Cancel
                            </button>
                            <button [disabled]="savingVideo()" (click)="saveDraft()" type="button"
                                class="primary-button inline-flex items-center gap-x-2">
                                @if (savingVideo()) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
                                    <path d="M20 6 9 17l-5-5" />
                                </svg>
                                } @else {
                                Save Draft
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
                                    <path d="M20 6 9 17l-5-5" />
                                </svg>
                                }
                            </button>
                        </div>
                        <!-- Footer - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>